var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-alert",class:{
    'alert-info': _vm.alert.type === 'info',
    'alert-error': _vm.alert.type === 'error',
    'alert-success': _vm.alert.type === 'success',
  }},[_c('Button',{attrs:{"theme":"close"},on:{"onClick":function($event){return _vm.$emit('close')}}}),_c('p',[_vm._v(_vm._s(_vm.alert.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }